import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useScopedSelector } from 'ia-react-core';
import { redirectTo } from 'omni-package-react-core';
import { OnboardingResourceInfo } from '~/components/OnboardingResource';
import { OnboardingData } from '~/interfaces/OnboardingData';
import OnboardingStatus from '~/interfaces/OnboardingStatus';
import { getCompanyByPath } from '~/utils/companyUtils';
import { setLocationHref } from '~/utils/browserNavigation';
import { Company } from '~/interfaces/CompanyConfig';
import Constants from '~/app/Constants';

export const useLogout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const onboarding: OnboardingData = useScopedSelector(OnboardingResourceInfo.dataDst);
  const isOnboardingCompleted = onboarding?.status === OnboardingStatus.Completed;
  const company: Company = getCompanyByPath(location.pathname);

  const getLogoutUrl = useCallback(() => {
    if (isOnboardingCompleted) {
      const logOffUrl = new URL(Constants.PagesUrl.SecureLogOff, window.location.origin);
      logOffUrl.searchParams.set('from', company);
      return logOffUrl.toString();
    }
    return Constants.PagesUrl.LogOff;
  }, [isOnboardingCompleted, company]);

  const logout = useCallback(() => {
    const logoutUrl = getLogoutUrl();

    if (isOnboardingCompleted) {
      setLocationHref(logoutUrl);
      return;
    }
    redirectTo(logoutUrl, navigate);
  }, [isOnboardingCompleted, navigate, getLogoutUrl]);

  return { logout, getLogoutUrl };
};
